export default __webpack_public_path__ + "static/media/Poppins-BlackItalic.9445d60e.ttf";